import React from 'react'
import Department05 from '../../../assets/image/department/department-5.jpg'
import Department06 from '../../../assets/image/department/department-6.jpg'
import Department07 from '../../../assets/image/department/department-7.jpg'
import Department08 from '../../../assets/image/department/department-8.jpg'
import Department09 from '../../../assets/image/department/department-9.jpg'
import Department10 from '../../../assets/image/department/department-10.jpg'
import { Link } from 'react-router-dom'


function First() {
  return (
    <>
        <section className="department-one-section">
            <div className="container">
                <div className="row row-gutter-30">
                <div className=" col-lg-6 col-xl-4 ">
                    <div className="department-two-card">
                    <div className="department-two-imgbox">
                        <div className="department-two-img">
                        <img src={Department05} className="img-fluid" alt="img-150" />
                        <Link to="/departmentdetails" />
                        </div>
                        
                        <div className="department-two-img-icon">
                        <Link to="/departmentdetails">
                            <i className="flaticon-team" />
                        </Link>
                        </div>
                       
                    </div>
                   
                    <div className="department-two-content">
                        <h4>
                        <Link to="/departmentdetails">Business &amp; Industry</Link>
                        </h4>
                        <p>
                        Aliq is notm hendr erit a augue insu image pellen simply free
                        text.
                        </p>
                        <div className="department-two-button">
                        <Link to="/departmentdetails">
                            <i className="fa-solid fa-arrow-right-long" />
                            <span>Read More</span>
                        </Link>
                        </div>
                        
                    </div>
                   
                    </div>
                    
                </div>
               
                <div className=" col-lg-6 col-xl-4 ">
                    <div className="department-two-card">
                    <div className="department-two-imgbox">
                        <div className="department-two-img">
                        <img src={Department06} className="img-fluid" alt="img-151" />
                        <Link to="/departmentdetails" />
                        </div>
                        
                        <div className="department-two-img-icon">
                        <Link to="/departmentdetails">
                            <i className="flaticon-police-badge-1" />
                        </Link>
                        </div>
                       
                    </div>
                   
                    <div className="department-two-content">
                        <h4>
                        <Link to="/departmentdetails">Policing and Crime</Link>
                        </h4>
                        <p>
                        Aliq is notm hendr erit a augue insu image pellen simply free
                        text.
                        </p>
                        <div className="department-two-button">
                        <Link to="/departmentdetails">
                            <i className="fa-solid fa-arrow-right-long" />
                            <span>Read More</span>
                        </Link>
                        </div>
                        
                    </div>
                   
                    </div>
                    
                </div>
               
                <div className=" col-lg-6 col-xl-4 ">
                    <div className="department-two-card">
                    <div className="department-two-imgbox">
                        <div className="department-two-img">
                        <img src={Department07} className="img-fluid" alt="img-152" />
                        <Link to="/departmentdetails" />
                        </div>
                        
                        <div className="department-two-img-icon">
                        <Link to="/departmentdetails">
                            <i className="flaticon-agriculture" />
                        </Link>
                        </div>
                       
                    </div>
                   
                    <div className="department-two-content">
                        <h4>
                        <Link to="/departmentdetails">Agriculture and Food</Link>
                        </h4>
                        <p>
                        Aliq is notm hendr erit a augue insu image pellen simply free
                        text.
                        </p>
                        <div className="department-two-button">
                        <Link to="/departmentdetails">
                            <i className="fa-solid fa-arrow-right-long" />
                            <span>Read More</span>
                        </Link>
                        </div>
                        
                    </div>
                   
                    </div>
                    
                </div>
               
                <div className=" col-lg-6 col-xl-4 ">
                    <div className="department-two-card">
                    <div className="department-two-imgbox">
                        <div className="department-two-img">
                        <img src={Department08} className="img-fluid" alt="img-153" />
                        <Link to="/departmentdetails" />
                        </div>
                        
                        <div className="department-two-img-icon">
                        <Link to="/departmentdetails">
                            <i className="flaticon-home" />
                        </Link>
                        </div>
                       
                    </div>
                   
                    <div className="department-two-content">
                        <h4>
                        <Link to="/departmentdetails">Housing and Land</Link>
                        </h4>
                        <p>
                        Aliq is notm hendr erit a augue insu image pellen simply free
                        text.
                        </p>
                        <div className="department-two-button">
                        <Link to="/departmentdetails">
                            <i className="fa-solid fa-arrow-right-long" />
                            <span>Read More</span>
                        </Link>
                        </div>
                        
                    </div>
                   
                    </div>
                    
                </div>
               
                <div className=" col-lg-6 col-xl-4 ">
                    <div className="department-two-card">
                    <div className="department-two-imgbox">
                        <div className="department-two-img">
                        <img src={Department09} className="img-fluid" alt="img-154" />
                        <Link to="/departmentdetails" />
                        </div>
                        
                        <div className="department-two-img-icon">
                        <Link to="/departmentdetails">
                            <i className="flaticon-art" />
                        </Link>
                        </div>
                       
                    </div>
                   
                    <div className="department-two-content">
                        <h4>
                        <Link to="/departmentdetails">Art and Culture</Link>
                        </h4>
                        <p>
                        Aliq is notm hendr erit a augue insu image pellen simply free
                        text.
                        </p>
                        <div className="department-two-button">
                        <Link to="/departmentdetails">
                            <i className="fa-solid fa-arrow-right-long" />
                            <span>Read More</span>
                        </Link>
                        </div>
                        
                    </div>
                   
                    </div>
                    
                </div>
               
                <div className=" col-lg-6 col-xl-4 ">
                    <div className="department-two-card">
                    <div className="department-two-imgbox">
                        <div className="department-two-img">
                        <img src={Department10} className="img-fluid" alt="img-155" />
                        <Link to="/departmentdetails" />
                        </div>
                        
                        <div className="department-two-img-icon">
                        <Link to="/departmentdetails">
                            <i className="flaticon-transportation" />
                        </Link>
                        </div>
                       
                    </div>
                   
                    <div className="department-two-content">
                        <h4>
                        <Link to="/departmentdetails">Roads and Transport</Link>
                        </h4>
                        <p>
                        Aliq is notm hendr erit a augue insu image pellen simply free
                        text.
                        </p>
                        <div className="department-two-button">
                        <Link to="#">
                            <i className="fa-solid fa-arrow-right-long" />
                            <span>Read More</span>
                        </Link>
                        </div>
                        
                    </div>
                   
                    </div>
                    
                </div>
               
                </div>
                
            </div>
        </section>
    </>
  )
}

export default First